import React, { useEffect, useState } from "react";
import { Card, ListGroup } from "react-bootstrap";
import ReactPlayer from "react-player";
import pendingBanner from "../../../../../assets/images/pendingBannerAudio.png";
import demo from "../../../../../assets/images/pendingIcons/demo.png";
import finish from "../../../../../assets/images/pendingIcons/finish.png";
import jury from "../../../../../assets/images/pendingIcons/jury.png";
import star from "../../../../../assets/images/pendingIcons/star.png";
import start from "../../../../../assets/images/pendingIcons/start.png";
import { Link, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import JuryJudgePanel from "../../../../Reuseable/JuryJudgePanel";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";

const StarAudioVideoPending = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const { id } = useParams();

  const audio = false;
  const video = true;

  const [event, setEvent] = useState({});
  const [judges, setJudges] = useState([]);
  const [juries, setJuries] = useState([]);

  useEffect(() => {
    axios.get(`/api/star/pending-audition/${id}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data.event);
        setJudges(res.data.judges);
        setJuries(res.data.juries);
      }
    });
  }, []);

    const approved = () => {
      axios.put(`/api/star/approved/audition/${id}`).then((res) => {
        if (res.status === 200) {
          history.push(`/superstar/audition`);
        }
      });
    };
    
    const decline = () => {
      axios.put(`/api/star/decline/audition/${id}`).then((res) => {
        if (res.status === 200) {
          history.push(`/superstar/audition`);
        }
      });
    };

  return (
    <>
      
        <div className="container-fluid">
          <h2 className="text-white">Request for approval</h2>
          <div className="requestApprovalBottomLine mb-4"></div>

          <div className="mainBorderPending p-5">
            <h3 className="text-primary fw-bolder my-2">{event.title}</h3>
            <p className="text-light my-2">
              <Markup content={event.description} />
            </p>

            <div className="my-3">
              <img
                src={imageCdnUrl+event.banner}
                className="img-fluid imgPending my-3 w-100"
                alt=""
              />
              <ReactPlayer
                className="mt-3"
                style={{
                  border: "2px solid gold",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
                url={videoCdnUrl+event.video}
                playing={false}
                volume={1}
                width="100%"
                // height="320px"
              />
            </div>
            <div className="row">
              {/* for judge  */}
              {judges? (
                <JuryJudgePanel
                  img={star}
                  title="Judge Panel"
                  data={judges}
                />
              ) : (
                <></>
              )}

              {/* for jury  */}

              {juries? (
                <JuryJudgePanel
                  img={jury}
                  title="Jury Panel"
                  data={juries}
                />
              ) : (
                <></>
              )}
              
              {/* for admin  */}
              {judges? (
                <JuryJudgePanel
                  img={jury}
                  title="Admins"
                  data={judges}
                  type="admin"
                />
              ) : (
                <></>
              )}
            </div>

            <div className="row">
              <div className="col-md-4 d-flex justify-content-center align-items-center">
                <Card style={{ width: "18rem" }} className="my-2">
                  <ListGroup variant="flush">
                    <ListGroup.Item className="d-flex juryItem justify-content-center">
                      <img className="demoStar" src={start} alt="" />
                      <div className="mx-2">
                        <p className="text-light">Starts</p>
                        <h5 className="text-light fw-bold">
                          {moment(event.start_time).format("LL")}
                        </h5>
                      </div>
                    </ListGroup.Item>
                  </ListGroup>
                </Card>
              </div>
              <div className="col-md-4 d-flex justify-content-center align-items-center">
                <Card style={{ width: "18rem" }} className="my-2">
                  <ListGroup variant="flush">
                    <ListGroup.Item className="d-flex juryItem justify-content-center">
                      <img className="demoStar" src={finish} alt="" />
                      <div className="mx-2">
                        <p className="text-light">Ends</p>
                        <h5 className="text-light fw-bold">
                          {moment(event.end_time).format("LL")}
                        </h5>
                      </div>
                    </ListGroup.Item>
                  </ListGroup>
                </Card>
              </div>
            </div>

            <div className="d-flex justify-content-evenly my-5">
              <button
                onClick={decline}
                className="text-primary btnPending rounded-3 p-2"
              >
                Rejected
              </button>
              <button
                onClick={approved}
                className="text-light btnApproved p-2 rounded-3"
              >
                Approved
              </button>
            </div>
          </div>
        </div>
    
    </>
  );
};

export default StarAudioVideoPending;
